// extracted by mini-css-extract-plugin
export var buttonContainer = "TextListModule-module--buttonContainer--5b61b";
export var contentContainer = "TextListModule-module--contentContainer--35a43";
export var rowTitle = "TextListModule-module--rowTitle--dc829";
export var text = "TextListModule-module--text--79bfc";
export var textRow = "TextListModule-module--textRow--b4172";
export var textRowsContainer = "TextListModule-module--textRowsContainer--30993";